export default __webpack_public_path__ + "static/media/us-nc.70dc53ce.svg";